export default __webpack_public_path__ + "static/1348-acff91e6c90e681ba46d7a9a9037692f.gif";